import { getEnterPriseIframeConfigApi, getEnterPriseIframeEncryptConfigApi, updateIframeEncryptStatus } from '../api';
import { useDispatch, useSelector } from '../../../react-redux';
import { getIframePlugin, setIframeEncrypt } from '../../../reducers/iframe-plugin';

const useEnterprise = () => {
  const dispatch = useDispatch();
  const iframePlugin = useSelector(state => state.getIn(['iframePlugin', 'data']));
  const iframeEncryptConfig = useSelector(state => state.getIn(['iframePlugin', 'encryptConfigData']));

  const handleGetIframePlugin = () => {
    getEnterPriseIframeConfigApi().then(res => {
      dispatch(getIframePlugin(res.data));
    });
  };

  const handleGetIframeEncryptConfig = () => {
    getEnterPriseIframeEncryptConfigApi().then(res => {
      dispatch(setIframeEncrypt(res.data));
    });
  };

  const handleChangeIframeEncryptConfig = checked => {
    return updateIframeEncryptStatus(checked).then(res => {
      if (res && res.data) {
        dispatch(setIframeEncrypt(res.data));
      }
    });
  };

  return {
    iframePlugin,
    iframeEncryptConfig,
    handleGetIframePlugin,
    handleGetIframeEncryptConfig,
    handleChangeIframeEncryptConfig
  };
};

export default useEnterprise;
